<template>
  <NuxtRouteAnnouncer/>
  <v-app>
    <v-navigation-drawer
      v-model:model-value="navigationDrawer"
      color="red-darken-4"
    >
      <v-list-item
        class="bg-red-darken-2 pb-0 pt-0" style="padding-top: 3px !important;"
      >
        <img src="/wiresock-logo-200x48-trans.png" alt="WireSock logo" height="48">
      </v-list-item>
      <v-list-item color="primary-darken-2" class="my-2">
        <v-row align="center">
          <v-col cols="3">
            <v-avatar color="red" size="40">
              <v-icon>mdi-shield-account</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="9">
            <div class="text-subtitle-2">{{ userName }}</div>
            <div class="text-caption text-medium-emphasis">Administrator</div>
          </v-col>
        </v-row>
      </v-list-item>
      <v-divider class="mb-4"></v-divider>

      <!-- Admin Navigation -->
      <v-list-item
        link
        title="Dashboard"
        prepend-icon="mdi-view-dashboard"
        to="/admin"
        exact
      ></v-list-item>
      <v-list-item
        link
        title="Manage Users"
        prepend-icon="mdi-account-group"
        to="/admin/users"
      ></v-list-item>
      <v-list-item
        link
        title="Generate License"
        prepend-icon="mdi-key-plus"
        to="/admin/licenses/generate"
      ></v-list-item>

      <v-list-subheader>AI assistant</v-list-subheader>
      <v-list-item
        link
        title="Assistant overview"
        prepend-icon="mdi-robot-outline"
        to="/admin/assistant"
        exact
      ></v-list-item>
      <v-list-item
        link
        title="Knowledge"
        prepend-icon="mdi-book-open-variant"
        to="/admin/assistant/items"
      ></v-list-item>
      <v-list-item
        link
        title="Review queue"
        prepend-icon="mdi-clipboard-check-outline"
        to="/admin/assistant/review"
      ></v-list-item>
      <v-list-item
        link
        title="Conversations"
        prepend-icon="mdi-forum-outline"
        to="/admin/assistant/conversations"
      ></v-list-item>

      <v-divider class="my-4"></v-divider>

      <!-- Back to Account -->
      <v-list-item
        link
        title="My Profile"
        prepend-icon="mdi-account"
        to="/account/profile"
      ></v-list-item>
    </v-navigation-drawer>

    <v-app-bar density="comfortable" elevation="0" border color="">
      <v-app-bar-nav-icon
        v-if="!navigationDrawer"
        @click="navigationDrawer = true"
      />
      <v-app-bar-title>
        <v-icon v-if="titleIcon" class="mr-2">{{ titleIcon }}</v-icon>
        {{ title }}
        <v-chip size="small" color="white" variant="outlined" class="ml-2">
          Admin
        </v-chip>
      </v-app-bar-title>
      <template #append>
        <v-btn variant="text" @click.stop.prevent="signout()">
          Logout
          <v-icon class="ml-2">mdi-logout</v-icon>
        </v-btn>
      </template>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
const auth = useAuth();
const route = useRoute();
const router = useRouter();

// Check admin role on mount and redirect if not admin
onMounted(async () => {
  await auth.getSession({ required: false });
  const user = auth.data.value?.user;
  if ((user as any)?.role !== 'ADMIN') {
    await router.push('/account?error=admin_access_required');
  }
});

// Also watch for session changes
watch(() => auth.data.value?.user, (user) => {
  if (user && (user as any)?.role !== 'ADMIN') {
    router.push('/account?error=admin_access_required');
  }
}, { immediate: false });

const title = computed(() => {
  return (route.meta.title as string) || 'Admin Dashboard';
});

const navigationDrawer = ref<boolean | null>(null);

const titleIcon = computed(() => {
  return route.meta.icon as string;
});

async function signout() {
  await auth.signOut({ callbackUrl: '/' });
}

const userName = computed<string>(() => {
  return auth.data.value?.user?.name || auth.data.value?.user?.email || 'Admin';
});
</script>

<style lang="css">
@media screen and (max-width: 960px) {
  body {
    padding-top: 0px;
  }
}
</style>

